import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StorageService } from '../services/storage/storage.service';

export const notAuthGuard: CanActivateFn = (route, segments) => {
  let storageService = inject(StorageService);
  let router = inject(Router);
  let token = storageService.hasToken();
  if (token) {
    return true;
  } else {
    router.navigate(['/']);
    return false;
  }
};
